import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { ReactComponent as LogoIcon } from 'icons/logo.svg';
import { ReactComponent as LogoTextIcon } from 'icons/logo_text.svg';
import { ReactComponent as MarkIcon } from 'icons/mark-2.svg';
import s from './AuthPanel.module.css';

const AuthPanel = ({ children, mode }) => {
  const [t, i18n] = useTranslation();

  const isLang = lang => i18n.languages[0] === lang;
  const setLang = lang => () => i18n.changeLanguage(lang);

  const renderLanguageSwitcher = className => (
    <div className={cn(s.switcher, className)}>
      <button className={cn({ [s.selected]: isLang('en') })} onClick={setLang('en')}>
        En
      </button>
      <button className={cn({ [s.selected]: isLang('ru') })} onClick={setLang('ru')}>
        Ru
      </button>
    </div>
  );

  return (
    <div className={cn(s.root, s[mode])}>
      <div className={s.left}>
        {children}
        {renderLanguageSwitcher(s.smallScreen)}
      </div>
      <div className={s.right}>
        {renderLanguageSwitcher()}
        <a href="https://loyal-up.com" className={s.logoLink}>
          <LogoIcon className={s.logo} />
          <LogoTextIcon color="white" className={s.logoText} />
        </a>
        {mode === 'login' ? (
          <div className={s.description}>{t('E-card платформа для управления программой лояльности')}</div>
        ) : (
          <div className={s.promo}>
            <div className={s.promoTitle}>
              {t('После регистрации вы получите полный доступ ко всем функциям сервиса, включая:')}
            </div>
            <ul className={s.features}>
              <li>
                <MarkIcon className={s.featuresMark} />
                {t('Регистрацию и работу с клиентами')}
              </li>
              <li>
                <MarkIcon className={s.featuresMark} />
                {t('Дизайн и выпуск карт')}
              </li>
              <li>
                <MarkIcon className={s.featuresMark} />
                {t('Рассылки Push-уведомлений и SMS')}
              </li>
              <li>
                <MarkIcon className={s.featuresMark} />
                {t('Рассылки по расписанию')}
              </li>
              <li>
                <MarkIcon className={s.featuresMark} />
                {t('Программа лояльности')}
              </li>
            </ul>
            <div className={s.promoHint}>
              {t(
                'Мы не требуем подключения кредитной карты или оплаты первые 28 дней использования сервиса. После окончания периода вы и дальше сможете пользоваться активными картами, но для добавления новых клиентов и активации новых карт вам будет необходим платный аккаунт.',
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

AuthPanel.propTypes = {
  children: PropTypes.node.isRequired,
  mode: PropTypes.oneOf(['login', 'register']),
};

AuthPanel.defaultProps = {
  mode: 'login',
};

export default AuthPanel;
